import React from "react";

import { ModelOptionBadge } from "src/genai/ModelSelector/ModelOptionBadge";

/**
 * Returns true if the routing target region is "Global".
 */
export const isGlobalRouting = (
  routingTargetRegion: string | null | undefined,
): boolean => routingTargetRegion === "Global";

const LearnMoreLink: React.FC = () => (
  <a
    className="text-indigo-400 underline hover:text-indigo-300"
    href="https://docs.taktile.com/decision-flow-fundamentals/node-types/ai-node#model-selection"
    rel="noopener noreferrer"
    target="_blank"
  >
    Learn more
  </a>
);

type RegionRoutingBadgeProps = {
  targetRegion: string;
};

/**
 * Badge indicating that a model is processed in a different or cross-region.
 */
export const RegionRoutingBadge: React.FC<RegionRoutingBadgeProps> = ({
  targetRegion,
}) => {
  if (isGlobalRouting(targetRegion)) {
    return <GlobalBadge />;
  }

  return (
    <ModelOptionBadge
      badgeConfig={{
        label: `Processed in ${targetRegion}`,
        tooltip: (
          <div>
            <div className="mb-1">{`Requests will be processed in the ${targetRegion}.`}</div>
            <LearnMoreLink />
          </div>
        ),
        pillVariant: "indigo-light",
      }}
    />
  );
};

/**
 * Badge indicating that a model is only available via a global endpoint.
 * regardless of the workspace region.
 */
export const GlobalBadge: React.FC = () => {
  return (
    <ModelOptionBadge
      badgeConfig={{
        label: "Processed globally",
        tooltip: (
          <div>
            <div className="mb-1">
              This model is only available via a global endpoint
            </div>
            <LearnMoreLink />
          </div>
        ),
        pillVariant: "yellow",
      }}
    />
  );
};
